import { Save, X } from "lucide-react";
import styles from "../editable-select-cell.module.scss";

export function ActionButtons({ isSaving, disabled, savingText, saveText, cancelText, onSave, onCancel }) {
	return (
		<div className={styles.actions}>
			<button
				type="button"
				className={styles.saveButton}
				onClick={(e) => {
					e.stopPropagation();
					e.preventDefault();
					onSave();
				}}
				onMouseDown={(e) => {
					e.stopPropagation();
				}}
				disabled={isSaving || disabled}
			>
				<Save className={styles.actionIcon} aria-hidden="true" />
				<span>{isSaving ? savingText : saveText}</span>
			</button>

			<button
				type="button"
				className={styles.cancelButton}
				onClick={(e) => {
					e.stopPropagation();
					e.preventDefault();
					onCancel();
				}}
				onMouseDown={(e) => {
					e.stopPropagation();
				}}
				disabled={isSaving}
			>
				<X className={styles.actionIcon} aria-hidden="true" />
				<span>{cancelText}</span>
			</button>
		</div>
	);
}
